export default "__VITE_ASSET__HmP0v_RZ__"